/* subidasDelBanco.js — LA SUBIDA DEL BANCO DEL PROFESOR, A NIVEL DE APP.
 *
 * REMATES-350 (PR #351, R-4 / #348) · REBANADAS-BANCO (PR #352, firmas #351, #352 y
 * el cabo de audio) · INFRA-1 (PR #354) · INFRA-3 (#381).
 *
 * ── EL BUG QUE CERRÓ #348 ────────────────────────────────────────────────────
 *
 * Hasta #348 la petición de subida vivía en `subir()` de `GroupBankSection`, en el
 * estado del componente. Cambiar de pantalla desmontaba la sección y con ella la
 * única referencia al resultado: la subida seguía en la red, pero nadie iba a
 * pintar la tarjeta ni a avisar, y un fallo tardío se perdía. Y mientras subía,
 * el botón sólo decía «cargando» —sin avance— y ningún aviso pedía no cerrar.
 *
 * ── EL BUG QUE CIERRA #352 ───────────────────────────────────────────────────
 *
 * La API pasa por Cloudflare, que rechaza con 413 cualquier cuerpo de más de 100 MB
 * sin llegar a Render y corta con 524 si el origen tarda más de 100 s. Un PDF de
 * 390 MB del banco no cabía por ese tubo de un golpe. Desde esta tanda TODO
 * documento y TODA grabación del banco viajan en REBANADAS numeradas (32 MiB en
 * #352; 8 MiB desde INFRA-1, firma #353 b),
 * cada una con su SHA-256, de una en una y en orden; el servidor las verifica, las
 * ensambla en orden y el archivo resultante es byte a byte el original. Las rutas
 * viejas siguen vivas en el servidor para la app ya instalada; este módulo ya no
 * las llama.
 *
 * ── INFRA-3 (#381): EL TRANSPORTE SE MUDÓ A `lib/transporteRebanadas.js` ────
 *
 * El troceo, el SHA-256, los reintentos por rebanada, el 401 acotado, los tres
 * techos, la espera de red, el refresco de sesión, la reanudación y el `cerrar`
 * con sus esperas son GENÉRICOS —la subida del alumno los usa igual— y viven ahí,
 * parametrizados por `urlBase`, prefijo de consola y `ponerPct`. Este módulo
 * conserva lo que es del banco: sus dos entradas públicas, el registro en vuelo
 * (una de documento y una de audio por grupo), los oyentes, los toasts con sus
 * llaves, el candado de cierre, el re-enganche en la app, el sondeo del cierre
 * asíncrono, y su línea de URL. Sus baterías siguen pasando sin más cambio que
 * el origen de las constantes que re-exporta.
 *
 * ── LO QUE HACE ──────────────────────────────────────────────────────────────
 *
 *   · Sostiene la subida AQUÍ (estado de módulo, una de documento y una de audio
 *     por grupo). Desmontar la sección no la toca; volver a montarla se re-engancha
 *     (`subidaEnVuelo`, `audioEnVuelo`, `suscribir`) y CONSULTA al servidor qué
 *     rebanadas ya tiene para seguir desde la primera que falte. Cerrar la pestaña
 *     (web) o que iOS mate la app SÍ la mata: el `File` ya no existe; el servidor
 *     limpia lo suyo (barrido / TTL) y el profesor vuelve a elegir el archivo.
 *   · Documento: pinta el toast persistente de arriba (`toast.loading` con `id` fijo
 *     por grupo y `duration: Infinity`) con el avance REAL: lo que el servidor ya
 *     confirmó más lo que el XHR lleva de la rebanada en vuelo. Sin `total` en el
 *     evento no hay porcentaje de esa rebanada: nunca un número inventado. Dos
 *     vocabularios por `IS_APP_BUILD`. Al terminar, el MISMO id pasa a
 *     `toast.success`; si falla, a `toast.error` con el texto que resuelve la
 *     pantalla (`textoDeFallo`), UNA sola vez.
 *   · Audio: el mismo transporte con `tipo: 'audio'` y su propio carril de estado
 *     (un documento y un audio pueden subir a la vez; dos audios del mismo grupo
 *     desde este dispositivo, no). Desde INFRA-1 (#353 a) el audio lleva EL MISMO
 *     aviso que el documento —botón «Subiendo… N %», toast persistente «no
 *     cierres», éxito con el nombre— reusando las llaves de #348: cero llaves
 *     nuevas. Cada tipo tiene su propio id de toast, o el segundo pisaría al
 *     primero cuando los dos suben al mismo grupo.
 *   · Reintentos por rebanada: red, timeout, 5xx o 422 `bank_rebanada_corrupta` →
 *     esperar 2 s, 5 s, 15 s y reenviar la MISMA n (Blob y FormData nuevos); agotadas
 *     las tres esperas, fallo definitivo. 404 caducada, 413, 403, 409, un 422 con
 *     otro código y cualquier otro 4xx → fallo definitivo de inmediato.
 *   · 401, ACOTADO A TRES (INFRA-1, censo C4a): el primero se reenvía (el
 *     interceptor de `api.js` ya refrescó), el segundo refresca explícitamente y
 *     reenvía, y el tercero da la sesión por terminada.
 *   · Tres techos por rebanada en vez de uno: 60 s sin latido de progreso, 90 s
 *     de espera de respuesta con el cuerpo ya enviado, y 15 min de último recurso.
 *   · Red caída: mientras `navigator.onLine === false` los reintentos ni corren ni
 *     cuentan; se espera `online` (o volver al frente); 10 min sin red → fallo. Al
 *     volver, primero `GET` estado (el servidor es la verdad) y se sigue desde la
 *     primera rebanada que falte.
 *   · Cierre: `POST cerrar`; un 422 incompleta con `faltantes` reenvía sólo ésas y
 *     cierra UNA vez más; 202/200 → sondeo `GET` (1 s la primera, luego cada 2 s)
 *     hasta `lista` o `fallida`, mostrando 100 % (los bytes sí llegaron). INFRA-1:
 *     son DOS rondas de sondeo de 10 min con un `cerrar` entre medias —ese segundo
 *     `cerrar` RELANZA un ensamblado que murió a medias— y sólo entonces
 *     `bank_subida_incompleta`. `lista` → el camino de éxito de siempre; `fallida`
 *     → el texto de la llave `errors` del `error_code`.
 *   · Sesión: `refrescarSesion()` antes de la rebanada 1 y antes de cualquier
 *     rebanada cuando el último refresco tenga más de 8 min (token de 15 min).
 *   · Candado de cierre en web (`beforeunload`) sólo para documentos, como hoy; en
 *     app, `visibilitychange` → visible re-pinta el toast y re-sincroniza.
 *
 * ── REGLAS DE LA CASA ────────────────────────────────────────────────────────
 *
 *   · Sin «Group» en el nombre a propósito (el censo del disco del candado sólo
 *     compara los que lo llevan); entra a `SUPERFICIE_GRUPOS` por lista para que
 *     el barrido de imports lo audite. Nada del consumidor entra aquí — y desde
 *     INFRA-3 el consumidor tampoco entra aquí: `PROHIBIDO_EN_CONSUMIDOR` lo nombra.
 *   · `lib/api` se pide DENTRO de la función y no arriba (ver la lección de
 *     `lib/referidos.js`): así este módulo no arrastra `i18n` al grafo de quien lo
 *     importe. `sonner` y `buildTarget` sí van arriba: no cargan nada.
 *   · Cero red en las pruebas: `lib/subidasDelBanco.rebanadas352.test.js` (módulo,
 *     servidor doblado), `lib/subidasDelBanco.remates350.test.js` (toasts, candado,
 *     app), `components/GroupBankSection.remates350.test.js` (pantalla) y, desde
 *     INFRA-1, `lib/subidasDelBanco.infra1.test.js` (8 MiB, los tres techos, el
 *     401 acotado, la reanudación y el porcentaje que no retrocede) con
 *     `components/GroupBankSection.infra1.test.js` (tarjeta doble, chip, audio). */
import { toast } from 'sonner';
import { IS_APP_BUILD } from './buildTarget';
import { DOC_DEL_BANCO_SUBIDO } from '../components/GroupBankVigilante';
import {
  REBANADA_BYTES, TECHO_INACTIVIDAD_MS, TECHO_RESPUESTA_MS, TECHO_REBANADA_MS,
  ESPERAS_REINTENTO_MS, MAX_401_SEGUIDOS, REFRESCO_CADA_MS, SIN_RED_MAX_MS,
  POLL_PRIMERA_MS, POLL_MS, CIERRE_MAX_MS, RONDAS_DE_CIERRE, TIPO_DOCUMENTO,
  registrar, cliente, ahora, rebanadasDe, bytesDe, sha256Puro, nombreDelHasher, sha256Hex,
  estadoDe, codigoDe, esReintentable, dormir, pedirResincronia, despertar,
  refrescar, SesionTerminada, bytesConfirmados, consultar, enviarFaltantes, cerrar,
  faltantesDe, abandonar, reanudar,
} from './transporteRebanadas';

export {
  REBANADA_BYTES, TECHO_INACTIVIDAD_MS, TECHO_RESPUESTA_MS, TECHO_REBANADA_MS,
  ESPERAS_REINTENTO_MS, MAX_401_SEGUIDOS, REFRESCO_CADA_MS, SIN_RED_MAX_MS,
  POLL_PRIMERA_MS, POLL_MS, CIERRE_MAX_MS, RONDAS_DE_CIERRE, TIPO_DOCUMENTO,
  rebanadasDe, bytesDe, sha256Puro, nombreDelHasher, sha256Hex, SesionTerminada,
};

export const TIPO_AUDIO = 'audio';

/** Cuánto se queda el toast de éxito (el del vigilante usa lo mismo). */
const DURACION_EXITO_MS = 10000;

/** Las subidas en vuelo: `${tipo}:${groupId}` → registro. */
const enVuelo = new Map();

/** Quién escucha cada grupo: `groupId` → Set de oyentes. Vive APARTE del registro
 *  de la subida, a propósito: la sección se suscribe al montar, cuando todavía no
 *  hay nada en vuelo, y tiene que enterarse de la subida que arranque después. */
const oyentes = new Map();

/** El id del toast persistente. POR GRUPO **Y POR TIPO** desde INFRA-1. */
export const idDelToast = (groupId, tipo = TIPO_DOCUMENTO) => (
  tipo === TIPO_AUDIO ? `pi-subida-audio-${groupId}` : `pi-subida-${groupId}`);

const clave = (tipo, groupId) => `${tipo}:${groupId}`;

/** `{ nombre, pct }` de la subida de DOCUMENTO en vuelo de ese grupo, o `null`. */
export function subidaEnVuelo(groupId) {
  const r = enVuelo.get(clave(TIPO_DOCUMENTO, groupId));
  return r ? { nombre: r.nombre, pct: r.pct } : null;
}

/** `{ nombre, pct }` de la subida de AUDIO en vuelo de ese grupo, o `null`. */
export function audioEnVuelo(groupId) {
  const r = enVuelo.get(clave(TIPO_AUDIO, groupId));
  return r ? { nombre: r.nombre, pct: r.pct } : null;
}

/** Escucha los eventos de las subidas de ese grupo (las que haya o las que arranquen). */
export function suscribir(groupId, fn) {
  if (!oyentes.has(groupId)) oyentes.set(groupId, new Set());
  const set = oyentes.get(groupId);
  set.add(fn);
  enVuelo.forEach((r) => { if (r.groupId === groupId) pedirResincronia(r); });
  return () => {
    set.delete(fn);
    if (set.size === 0) oyentes.delete(groupId);
  };
}

function avisarA(registro, evento) {
  const set = oyentes.get(registro.groupId);
  if (!set) return;
  Array.from(set).forEach((fn) => {
    try { fn({ tipo: registro.tipo, ...evento }); } catch (e) { /* un oyente roto no tumba a los demás */ }
  });
}

/** El texto del botón de subir mientras sube. */
export function textoDelBoton(t, pct) {
  return pct === null || pct === undefined
    ? t('groups.bank.subida.btn')
    : t('groups.bank.subida.btn_pct', { pct });
}

function textoDelToast(t, nombre, pct) {
  const sinPct = pct === null || pct === undefined;
  if (IS_APP_BUILD) {
    return sinPct
      ? t('groups.bank.subida.toast_app', { nombre })
      : t('groups.bank.subida.toast_app_pct', { nombre, pct });
  }
  return sinPct
    ? t('groups.bank.subida.toast_web', { nombre })
    : t('groups.bank.subida.toast_web_pct', { nombre, pct });
}

function pintarToast(r) {
  toast.loading(textoDelToast(r.t, r.nombre, r.pct),
    { id: idDelToast(r.groupId, r.tipo), duration: Infinity });
}

/* ── EL PORCENTAJE NUNCA BAJA (#353 c) ───────────────────────────────────────
 * El número visible es un MÁXIMO: sólo sube. El contador interno (`r.recibidas`) es el
 * que decide qué reenviar. */
function ponerPct(r, pct) {
  if (pct === null) {
    if (r.pct === null) return;
    r.pct = null;
  } else {
    const nuevo = Math.max(0, Math.min(100, Math.floor(pct)));
    if (nuevo <= (r.pct === null ? -1 : r.pct)) return;
    r.pct = nuevo;
  }
  pintarToast(r);
  avisarA(r, { estado: 'subiendo', pct: r.pct, nombre: r.nombre });
}

/** Cuántos documentos hay en vuelo (para el candado de cierre en web). */
const documentosEnVuelo = () => Array.from(enVuelo.values()).filter((r) => r.tipo === TIPO_DOCUMENTO).length;

// ── El candado de cierre (web) ──────────────────────────────────────────────
function alCerrar(e) {
  e.preventDefault();
  e.returnValue = '';
  return '';
}
let candadoPuesto = false;
function actualizarCandado() {
  if (IS_APP_BUILD || typeof window === 'undefined') return;
  if (documentosEnVuelo() > 0 && !candadoPuesto) {
    window.addEventListener('beforeunload', alCerrar);
    candadoPuesto = true;
  } else if (documentosEnVuelo() === 0 && candadoPuesto) {
    window.removeEventListener('beforeunload', alCerrar);
    candadoPuesto = false;
  }
}

// ── El re-enganche al volver del fondo (app) y al volver la red ─────────────
function alVolver() {
  if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
  enVuelo.forEach((r) => { pintarToast(r); pedirResincronia(r); despertar(r); });
}
function alVolverLaRed() {
  enVuelo.forEach((r) => { pedirResincronia(r); despertar(r); });
}
let oidoPuesto = false;
function actualizarOido() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (enVuelo.size > 0 && !oidoPuesto) {
    if (IS_APP_BUILD) document.addEventListener('visibilitychange', alVolver);
    window.addEventListener('online', alVolverLaRed);
    oidoPuesto = true;
  } else if (enVuelo.size === 0 && oidoPuesto) {
    if (IS_APP_BUILD) document.removeEventListener('visibilitychange', alVolver);
    window.removeEventListener('online', alVolverLaRed);
    oidoPuesto = false;
  }
}

function soltar(registro) {
  enVuelo.delete(clave(registro.tipo, registro.groupId));
  actualizarCandado();
  actualizarOido();
}

// ── El servidor ─────────────────────────────────────────────────────────────

const urlBase = (r) => `/groups/${r.groupId}/bank/upload`;

function fallidaComoError(r, codigo) {
  const codigoFinal = codigo || 'bank_subida_incompleta';
  const llave = `common:errors.${codigoFinal}`;
  let detail = null;
  try {
    const texto = r.t(llave);
    if (typeof texto === 'string' && texto && texto !== llave) detail = texto;
  } catch (e) { /* sin traducción: la pantalla cae a su genérico */ }
  return Object.assign(new Error(codigoFinal), {
    response: { status: 422, data: { error_code: codigoFinal, detail } },
  });
}

/** Una ronda de sondeo: hasta `lista` / `fallida`, o `null` al agotar los 10 min. */
async function sondearUnaRonda(r, api) {
  const desde = ahora();
  await dormir(POLL_PRIMERA_MS);
  for (;;) {
    try {
      const datos = await consultar(r, api);
      if (datos.estado === 'lista' || datos.estado === 'fallida') return datos;
    } catch (err) {
      if (!esReintentable(err) && estadoDe(err) !== 401) throw err;
    }
    if (ahora() - desde >= CIERRE_MAX_MS) return null;
    await dormir(POLL_MS);
  }
}

/** Sondea el cierre. DOS RONDAS, con un `cerrar` delante de la segunda (INFRA-1). */
async function esperarCierre(r, api) {
  for (let ronda = 0; ronda < RONDAS_DE_CIERRE; ronda += 1) {
    if (ronda > 0) {
      try {
        await cerrar(r, api);            // el `cerrar` que relanza el cierre muerto
      } catch (err) {
        if (estadoDe(err) === 422 && codigoDe(err) === 'bank_subida_incompleta') throw err;
      }
    }
    const datos = await sondearUnaRonda(r, api);
    if (datos) return datos;
  }
  return { estado: 'fallida', error_code: 'bank_subida_incompleta' };
}

// ── La subida, de punta a punta ─────────────────────────────────────────────

async function correr(r) {
  const { default: api, refrescarSesion } = cliente();
  const { groupId, nombre, t } = r;
  try {
    r.n = rebanadasDe(r.size);
    await refrescar(r, refrescarSesion);
    let ini = await api.post(`${urlBase(r)}/iniciar`, { nombre, tamano: r.size, tipo: r.tipo, n: r.n });
    r.subidaId = ini?.data?.subida_id;
    r.recibidas = new Set(ini?.data?.recibidas || []);
    if (!r.subidaId) throw new Error('iniciar sin subida_id');
    registrar('info', `[pipe-inst] subida abierta subida=${r.subidaId} partes=${r.n} hasher=${nombreDelHasher()}`);

    let saltarAlCierre = false;
    if (ini?.data?.reanudada === true) {
      const sirvio = await reanudar(r, api, ini?.data?.shas || {});
      if (!sirvio) {
        // Otro archivo con el mismo nombre y tamaño: fuera lo viejo y de cero.
        await abandonar(r, api);
        r.subidaId = null;
        ini = await api.post(`${urlBase(r)}/iniciar`, { nombre, tamano: r.size, tipo: r.tipo, n: r.n });
        r.subidaId = ini?.data?.subida_id;
        r.recibidas = new Set(ini?.data?.recibidas || []);
        if (!r.subidaId) throw new Error('iniciar sin subida_id');
      } else if (ini?.data?.estado === 'ensamblando') {
        saltarAlCierre = true;
      }
    }

    let final = saltarAlCierre ? null : await enviarFaltantes(r, api, refrescarSesion);
    if (!final) {
      try {
        final = await cerrar(r, api);
      } catch (err) {
        if (!(estadoDe(err) === 422 && codigoDe(err) === 'bank_subida_incompleta')) throw err;
        // Sólo las que el servidor dice que faltan, y UN cierre más.
        faltantesDe(err).forEach((n) => r.recibidas.delete(n));
        await enviarFaltantes(r, api, refrescarSesion);
        final = await cerrar(r, api);
      }
    }
    ponerPct(r, 100);
    if (final.estado !== 'lista' && final.estado !== 'fallida') final = await esperarCierre(r, api);
    if (final.estado !== 'lista') throw fallidaComoError(r, final.error_code);

    const documento = final.document || null;
    soltar(r);
    toast.success(t('groups.bank.subida.listo', { nombre }),
      { id: idDelToast(groupId, r.tipo), duration: DURACION_EXITO_MS });
    if (typeof window !== 'undefined') window.dispatchEvent(new Event(DOC_DEL_BANCO_SUBIDO));
    avisarA(r, { estado: 'listo', documento, nombre });
    return { ok: true, documento };
  } catch (err) {
    soltar(r);
    toast.dismiss(idDelToast(groupId, r.tipo));
    if (err && err.sesionTerminada) {
      // La sesión se acabó: cero texto nuevo (diseño §5.3 B). La subida NO se abandona
      // en el servidor a propósito; el aviso sólo si el refresco SÍ funcionó.
      registrar('warn', `[pipe-inst] subida fallida subida=${r.subidaId} code=sesion`);
      if (err.refrescoOk) toast.error(r.textoDeFallo(err));
      avisarA(r, { estado: 'error', error: err, nombre, sesionTerminada: true });
      return { ok: false, error: err };
    }
    registrar('warn',
              `[pipe-inst] subida fallida subida=${r.subidaId} code=${codigoDe(err) || estadoDe(err) || 'red'}`);
    toast.error(r.textoDeFallo(err));
    await abandonar(r, api);
    avisarA(r, { estado: 'error', error: err, nombre });
    return { ok: false, error: err };
  }
}

function arrancar({ tipo, groupId, file, t, textoDeFallo }) {
  const previa = enVuelo.get(clave(tipo, groupId));
  if (previa) {
    toast.info(t('groups.bank.subida.espera'));
    return { ocupado: true, promesa: previa.promesa };
  }
  const registro = {
    tipo, groupId, file, nombre: file.name, size: file.size, pct: null, t, textoDeFallo,
    promesa: null, n: 0, subidaId: null, recibidas: new Set(), ultimoRefresco: null,
    resincronizar: false, despertar: null, refrescoOk: true,
    // INFRA-3: lo que el transporte genérico necesita saber de este registro.
    prefijo: '[pipe-inst]',
  };
  registro.urlBase = urlBase(registro);
  registro.ponerPct = (pct) => ponerPct(registro, pct);
  enVuelo.set(clave(tipo, groupId), registro);
  actualizarCandado();
  actualizarOido();
  pintarToast(registro);
  registro.promesa = correr(registro);
  return { ocupado: false, promesa: registro.promesa };
}

/**
 * Arranca la subida de `file` (documento) al banco de `groupId`.
 *
 * @param {object} p
 * @param {string} p.groupId
 * @param {File} p.file
 * @param {Function} p.t  la `t` de la pantalla (idioma del usuario, ns `dashboard`)
 * @param {Function} p.textoDeFallo  `(err) => string`, el mismo resolutor de la pantalla
 * @returns {{ ocupado: boolean, promesa: Promise }}  `ocupado` si ya había una en vuelo
 *          para ese grupo (no se manda nada; se avisa con `toast.info`).
 */
export function subirDocumentoAlBanco({ groupId, file, t, textoDeFallo }) {
  return arrancar({ tipo: TIPO_DOCUMENTO, groupId, file, t, textoDeFallo });
}

/**
 * Arranca la subida de `file` (grabación) al banco de `groupId`, por el mismo
 * transporte y con su propio carril de estado. INFRA-1 (#353 a): con EL MISMO AVISO
 * que el documento, reusando las llaves de #348 —cero llaves nuevas— y con su propio
 * id de toast.
 */
export function subirAudioAlBanco({ groupId, file, t, textoDeFallo }) {
  return arrancar({ tipo: TIPO_AUDIO, groupId, file, t, textoDeFallo });
}
